<template>
  <page-wrapper title="Subscriber Report Page" ref="pageEl">
    <div class="page-container">
      <div class="row mb-7" style="padding: 15px">
        <div class="md-1">
          <div class="label col-5">วันที่</div>
          <date-picker
            v-model="dateRange"
            :disabled="!isDropdownDisabled"
            type="daterange"
          ></date-picker>
        </div>
        <div class="space md-2">
          <div class="label col-7">ประเภทวัน</div>
          <el-select v-model="query.dateType"
          :disabled="!isDropdownDisabled"
          clearable>
            <el-option
              v-for="t in filterDate"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
          </el-select>
        </div>
        <div class="space md-2">
          <div class="label col-5">สถานะ</div>
          <el-select v-model="query.status"
          :disabled="!isDropdownDisabled"
          clearable>
            <el-option
              v-for="t in filterStatus"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
          </el-select>
        </div>
        <div class="space md-2">
          <div class="label col-5">ประเภท</div>
          <el-select v-model="query.type"
          :disabled="!isDropdownDisabled"
          clearable>
            <el-option
              v-for="t in filterType"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
          </el-select>
        </div>
        <div class="space md-2">
          <div class="label col-7">หมวดหมู่</div>
          <el-select v-model="query.category"
          :disabled="!isDropdownDisabled"
          clearable>
            <el-option
              v-for="t in filterCategory"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-4">
          <div class="label">ค้นหาโครงการ</div>
          <project-select v-model="selectedProject"
          :disabled="!isDropdownDisabled" >
          </project-select>
        </div>
        <div class="col-2">
          <div class="label">ประเภทเอกสาร</div>
          <el-select v-model="query.receiptTypeTH"
          :disabled="!isDropdownDisabled"
          style="width: 100%" clearable>
            <el-option
              v-for="t in filterReceiptType"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
          </el-select>
        </div>
        <div class="col-3">
          <div class="label">ประเภทบริษัท</div>
          <el-select v-model="query.companyType"
          :disabled="!isDropdownDisabled"
          clearable>
            <el-option
              v-for="t in filterCompanyType"
              :key="t.value"
              :label="t.label"
              :value="t.value"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="mb-4">
        <div class="label">เลขที่เอกสาร/Subscription ID</div>
        <el-input
          class="text-document"
          v-model="query.documentNumber"
          :disabled="!isSearchDisabled"
          type="textarea"
          rows="3"
          placeholder="ใส่ , คั่นเลขเอกสาร (Ex: 2019010001,2019010002)"
        ></el-input>
      </div>
      <div class="text-left mt-2">
        <el-checkbox
          v-model="isFilteredByMNC"
          @change="handleClickSearch"
          ><p class="checkbox-font">
            รายการที่ใช้ MNC
          </p></el-checkbox
        >
      </div>
      <div class="text-right mt-2">
        <sc-button variant="warning"
        :disabled="!isClearDisabled"
        @click="handleClickClear"
         >clear</sc-button>
      </div>
      <div class="text-right mt-2">
        <sc-button variant="primary"
        :disabled="!isSearchDisabled"
        @click="handleClickSearch"
          >ค้นหา</sc-button
        >
      </div>
      <div>
        <button variant="secondary" :disabled="!isClickDownloadAsCSVDisabled"
        @click.prevent="handleClickDownloadAsCSV">
          Download
        </button>
        <button
          variant="secondary"
          :disabled="!isClickDownloadWithIncentiveAsCSVDisabled"
          @click.prevent="handleClickDownloadWithIncentiveAsCSV"
        >
          Download (with Incentive)
        </button>
      </div>
      <div class="report-container">
        <div class="row mt-3">
          <div class="col-12" v-show="latest_update_time != null">
            <b>{{ latest_update_message }}</b>
          </div>
          <div class="col-6">{{ totalCount }}</div>
          <div class="col-6 top-page">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :disabled="!isPaginationDisable"
              :current-page="query.page"
              :page-size="30"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </div>
        </div>
        <div class="report-table">
          <div
            class="report-row"
            :class="{ header: index === 0 }"
            v-for="(report, index) in reportPresenters"
          >
            <div class="report-subscription">
              <div
                class="report-subscription-row"
                v-for="subscription in report.subscriptions"
              >
                <div class="report-subscription-histories">
                  <div
                    class="report-subscription-histories-row"
                    v-for="history in subscription.histories"
                  >
                    <div class="report-service">
                      <div
                        class="report-service-row"
                        v-for="(service, indexService) in history.services"
                      >
                        <div class="report-appointment">
                          <div
                            class="report-appointment-row"
                            v-for="(
                              appointment, indexAppointment
                            ) in service.appointments"
                            :class="[history.status.toLowerCase()]"
                          >
                            <div class="name report-cell">
                              {{ history.order_number }}
                            </div>
                            <div class="name report-cell">
                              {{ history.user_id }}
                            </div>
                            <div class="name report-cell">
                              {{ history.name }}
                            </div>
                            <div class="gender report-cell">
                              {{ report.gender }}
                            </div>
                            <div class="mobile-number report-cell">
                              {{ report.mobile_number }}
                            </div>
                            <div class="date-of-birth report-cell">
                              {{ report.date_of_birth }}
                            </div>
                            <div class="tax-id report-cell">
                              {{ report.tax_id }}
                            </div>
                            <div class="name report-cell">
                              {{ subscription.project_name }}
                            </div>
                            <div class="name report-cell">
                              {{ subscription.address }}
                            </div>
                            <div class="name report-cell">
                              {{ subscription.package_id }}
                            </div>
                            <div class="name report-cell">
                              <router-link
                                target="_blank"
                                v-if="subscription.id && isRouterLinkDisabled"
                                :to="{
                                  name: 'SubscriberDetailPage',
                                  params: { id: subscription.id },
                                }"
                                >{{ subscription.package_name }}</router-link
                              >
                              <span v-else>{{
                                subscription.package_name
                              }}</span>
                            </div>
                            <div class="name report-cell">
                              {{ appointment.seller_trade }}
                            </div>
                            <div class="name report-cell">
                              <pre class="report-group">{{
                                subscription.group_name
                              }}</pre>
                            </div>
                            <div class="name report-cell">
                              {{ subscription.package_type }}
                            </div>
                            <div class="name report-cell text-center status">
                              {{ history.subscription_status }}
                            </div>
                            <div class="name report-cell text-center status">
                              {{ history.billing_status }}
                            </div>
                            <div class="name report-cell text-center status">
                              {{ history.actual_status }}
                            </div>
                            <div class="report-cell text-center">
                              {{ history.paid_on }}
                            </div>
                            <div class="report-cell text-center">
                              {{ history.time_paid_on }}
                            </div>
                            <div class="report-cell text-center">
                              {{ history.effectived_at }}
                            </div>
                            <div class="report-cell text-center">
                              {{ history.expired_at }}
                            </div>
                            <div class="report-cell text-center">
                              {{ appointment.main_option_title }}
                            </div>
                            <div class="report-cell text-center">
                              {{ appointment.extra_option_title }}
                            </div>
                            <div class="report-cell text-center">
                              {{ appointment.main_option_price }}
                            </div>
                            <div class="report-cell text-center">
                              {{ appointment.extra_option_price }}
                            </div>
                            <div class="report-cell text-center">
                              {{ appointment.quantity }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ history.selling_price }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ history.coupon_code }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ history.price }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ history.vat }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ history.price_with_out_vat }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ history.total_coin_amount }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ history.total_coin_price }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ history.income_before_mdr_vat }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ history.total_mdr }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ history.income_fee_rate_text }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ history.net_fee }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ history.income }}
                            </div>
                            <div class="report-cell text-right">
                              <a target="_blank"
                                :href="history.receipt_bank_transfer"
                                v-if="history.receipt_bank_transfer"
                                >{{
                                  history.payment_channel
                                }}</a>
                                <template v-else>{{
                                  history.payment_channel
                                }}</template>
                            </div>
                            <div class="report-cell text-center">
                              <router-link
                                target="_blank"
                                :to="{
                                  name: 'ReceiptDetailPage',
                                  params: {
                                    id: history.credit_note_document_number_id,
                                  },
                                }"
                                >{{
                                  history.credit_note_document_number ||
                                  history.credit_note_document_number_id
                                }}</router-link
                              >
                            </div>
                            <div class="report-cell text-left">
                             {{
                                history.refund_remark
                              }}
                            </div>
                            <div class="report-cell text-left">
                              <pre class="report-billing">{{
                                history.bill_address
                              }}</pre>
                            </div>
                            <div class="report-cell text-center">
                              <router-link
                                target="_blank"
                                :to="{
                                  name: 'ReceiptDetailPage',
                                  params: { id: appointment.receipt_id },
                                }"
                                v-if="appointment.receipt_id"
                                >{{
                                  appointment.receipt_document_number ||
                                  appointment.receipt_id
                                }}</router-link
                              >
                              <template v-else>{{
                                appointment.receipt_document_number
                              }}</template>
                            </div>
                            <div class="report-cell">{{ service.name }}</div>
                            <div class="report-cell">
                              {{ appointment.provider_name }}
                            </div>
                            <div class="report-cell">
                              {{ appointment.provider_name_on_sap }}
                            </div>
                            <div class="report-cell">
                              {{ appointment.sap_service_type }}
                            </div>
                            <div class="report-cell">
                              {{ appointment.provider_name_by_appointment }}
                            </div>
                            <div class="report-cell">
                              {{ appointment.cost_before_vat }}
                            </div>
                            <div class="report-cell">
                              {{ appointment.cost }}
                            </div>
                            <div class="report-cell text-center">
                              <router-link
                                target="_blank"
                                v-if="appointment.is_appointment_have_remark"
                                :to="{
                                  name: 'AppointmentDetailPage',
                                  params: { id: appointment.id },
                                }"
                                >Remarks</router-link
                              >
                            </div>
                            <div class="report-cell text-center">
                              {{ appointment.booked_on }}
                            </div>
                            <div class="report-cell text-center">
                              <router-link
                                target="_blank"
                                v-if="appointment.id"
                                :to="{
                                  name: 'AppointmentDetailPage',
                                  params: { id: appointment.id },
                                }"
                                >{{ appointment.appointment_date }}</router-link
                              >
                              <template v-else>{{
                                appointment.appointment_date
                              }}</template>
                            </div>
                            <div class="report-cell text-center">
                              {{ appointment.period_appointment_date_time }}
                            </div>
                            <div class="report-cell text-center">
                              {{ appointment.confirmed }}
                            </div>
                            <div class="report-cell text-center">
                              {{ appointment.used }}
                            </div>
                            <div class="report-cell text-center">
                              {{ appointment.fulfilled_at }}
                            </div>
                            <div class="report-cell text-right">
                              {{ history.ref_code }}
                            </div>
                            <div class="report-cell text-center">
                              {{ appointment.receipt_date }}
                            </div>
                            <div class="report-cell text-center">
                              {{ appointment.receipt_number }}
                            </div>
                            <div class="report-cell text-center">
                              {{ appointment.actual_cost }}
                            </div>
                            <div class="report-cell">
                              {{ history.note }}
                            </div>
                            <div class="report-cell">
                              {{ appointment.maintenance_request }}
                            </div>
                            <div class="report-cell">
                              {{ appointment.po_number }}
                            </div>
                            <div class="report-cell">
                              {{ appointment.sap_cost }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ history.wallet_name }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="wrapper page">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :current-page="query.page"
            :page-size="30"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import DatePicker from "@/lib/components/DatePicker";
import { DateTime } from "luxon";
import PageWrapper from "@/lib/components/PageWrapper";
import { baanRueJaiClient } from "@/dependencies";
import ScButton from "@/lib/components/ScButton";
import { toLocaleTH } from "@/lib/dateTime";
import * as R from "ramda";
import {
  Select,
  Option,
  Input,
  Pagination,
  Checkbox
} from "element-ui";
import { convertCsvToExcelBuffer } from "@/lib/util"
import ProjectSelect from "@/lib/components/ProjectSelect";

export default {
  components: {
    PageWrapper,
    DatePicker,
    ScButton,
    "el-select": Select,
    "el-option": Option,
    "el-input": Input,
    ProjectSelect,
    "el-pagination": Pagination,
    "el-checkbox": Checkbox
  },
  data() {
    const filterDate = [
      { label: "ทั้งหมด", value: "" },
      { label: "วันชำระ", value: "paidOn" },
      { label: "วันนัด", value: "appointmentDate" },
      { label: "วันสิ้นสุด", value: "expiredAt" },
      { label: "ใช้เมื่อ", value: "used" },
      { label: "วันที่ใบเสร็จจาก vendor", value: "vendorReceipt" },
      { label: "วันปิดงาน", value: "fulfilled" }
    ];
    const filterStatus = [
      { label: "ทั้งหมด", value: "" },
      { label: "Active", value: "active" },
      { label: "Cancelled", value: "cancelled" },
      { label: "Unsubscribed", value: "unsubscribed" },
      { label: "Expired", value: "expired" }
    ];
    const filterType = [
      { label: "ทั้งหมด", value: "" },
      { label: "Free Trial", value: "freeTrial" },
      { label: "One Time", value: "oneTime" },
      { label: "Subscribe", value: "subscribe" }
    ];
    const filterCategory = [
      { label: "ทั้งหมด", value: "" },
      { label: "Home Expert", value: "Home Expert" },
      { label: "Life Style", value: "Lifestyle" },
      { label: "Subscription", value: "Subscription" },
      { label: "Ruejai Club", value: "Ruejai Club" },
      { label: "RJB2B", value: "RJB2B" }
    ];
    const filterReceiptType = [
      { label: "ทั้งหมด", value: "" },
      { label: "ใบเสร็จรับเงิน/ใบกำกับภาษี", value: "RECEIPT_AND_TAX_INVOICE" },
      { label: "ใบกำกับภาษี", value: "TAX_INVOICE" },
      { label: "ใบลดหนี้", value: "CREDIT_NOTE" },
    ]
    const filterCompanyType = [
      { label: "ทั้งหมด", value: "" },
      { label: "SC Asset", value: "SC_ASSET" },
      { label: "SC Able", value: "SC_ABLE" }
    ]

    return {
      searchProjectResult: [],
      reports: [],
      dateRange: [],
      filterDate,
      filterStatus,
      filterType,
      filterCategory,
      query: [],
      selectedProject: null,
      filterReceiptType,
      filterCompanyType,
      total: 0,
      isClearDisabled: true,
      isSearchDisabled: true,
      isClickDownloadAsCSVDisabled: true,
      isClickDownloadWithIncentiveAsCSVDisabled: true,
      isPaginationDisable: true,
      isDropdownDisabled: true,
      isRouterLinkDisabled:true,
      isFilteredByMNC: false,
      latest_update_time: null
    };
  },
  computed: {
    reportPresenters() {
      const header = {
        user_id: "User ID",
        mobile_number: "เบอร์ติดต่อ",
        date_of_birth: "ปีเกิด",
        tax_id: "Tax ID",
        subscriptions: [
          {
            address: "ที่อยู่",
            package_name: "แพ็กเกจ",
            package_id: "Package ID",
            package_price: "ราคา",
            project_name: "โครงการ",
            histories: [
              {
                order_number: "ลำดับ",
                paid_on: "วันชำระ",
                time_paid_on: "เวลาที่ชำระ",
                effectived_at: "วันเริ่ม",
                expired_at: "วันสิ้นสุด",
                price: "ราคาขายสุทธิ (รวม VAT)",
                price_with_out_vat: "ราคาขาย (ก่อน VAT)",
                vat: "VAT",
                total_mdr: "MDR+VAT",
                income_fee_rate_text: "อัตราค่าธรรมเนียม",
                net_fee: "ค่าธรรมเนียมสุทธิ",
                income: "เงินรับสุทธิ",
                payment_channel: "ช่องทางการชำระเงิน",
                credit_note_document_number_id: "เลขที่ใบลดหนี้",
                actived: "ACTIVED",
                bill_address: "ข้อมูลที่ใช้ออกใบเสร็จ",
                coupon_code: "ส่วนลด",
                ref_code: "รหัสอ้างอิง",
                selling_price: "ราคาขาย (รวม VAT)",
                total_coin_amount: "จำนวน MNC (MNC)",
                total_coin_price: "มูลค่า MNC (บาท)",
                wallet_name: "Wallet Name",
                income_before_mdr_vat: "เงินรับสุทธิก่อน (MDR+VAT)",
                note: "หมายเหตุ",
                status: "สถานะ",
                name: "ชื่อ",
                gender: "เพศ",
                services: [
                  {
                    name: "บริการ",
                    appointments: [
                      {
                        is_appointment_have_remark: 'Appointment Remarks',
                        cost: "ต้นทุนประมาณการ (หลัง Vat)",
                        booked_on: "นัดเมื่อ",
                        appointment_date: "วันนัด",
                        confirmed: "Confirmed",
                        main_option_title: "Option หลัก",
                        extra_option_title: "Optiong เสริม",
                        main_option_price: "ราคา Option หลัก",
                        extra_option_price: "ราคา Option เสริม",
                        quantity: "จำนวนต่อ Package",
                        used: "ใช้เมื่อ",
                        receipt_date: "วันที่ใบเสร็จจากVendor",
                        receipt_number: "เลขที่ใบเสร็จจากVendor",
                        actual_cost: "ต้นทุนจริง",
                        receipt_document_number: "เลขที่ใบเสร็จ",
                        cost_before_vat: "ต้นทุนประมาณการ (ก่อน Vat)",
                        seller_trade: "บริษัท",
                        fulfilled_at: "ปิดงาน",
                        maintenance_request: "เลขที่ใบแจ้งซ่อม",
                        provider_name: "ผู้ให้บริการ",
                        provider_name_on_sap: "ชื่อผู้ให้บริการบน sap",
                        period_appointment_date_time: "เวลานัด",
                        provider_name_by_appointment: "ชื่อผู้ให้บริการรายนัดหมาย",
                        sap_service_type: "ประเภทของสินค้าและบริการ (SAP)",
                        po_number: "PO_NUMBER",
                        sap_cost: "ราคาต้นทุนที่ส่ง sap"
                      }
                    ]
                  }
                ],
                refund_remark: "Remark ของ Refund",
                subscription_status: "สถานะ Transaction",
                billing_status: "สถานะตามรอบบิล",
                actual_status: "สถานะตามจริง"
              }
            ],
            group_name: "หมวดหมู่",
            package_type: "ประเภท",
            cancelled_at: "ยกเลิกเมื่อ",
            is_free_trial: "ทดลองใช้"
          }
        ]
      };

      return [header, ...this.reports];
    },
    queryParams() {
      const {
        from,
        to,
        dateType,
        status,
        type,
        category,
        selectedProject,
        receiptTypeTH,
        companyType,
        page,
        documentNumber,
        isFilteredByMNC
      } = this.$route.query;

      return {
        from,
        to,
        dateType,
        status,
        type,
        category,
        selectedProject,
        receiptTypeTH,
        companyType,
        page: page && +page || 1,
        documentNumber,
        isFilteredByMNC
      };
    },
    totalCount() {
      if (!this.total || this.total === 0) {
        return "ไม่พบข้อมูล";
      }
      const limit = 30;
      const total = this.total.toLocaleString();
      const currentTotalItem = this.reports.reduce(
        (total, user) => total + (user.subscriptions.reduce(
          (all, current) => all + current.histories.length, 0
        )), 0
      )

      const isLastPage = limit > currentTotalItem;
      const currentPage = this.query.page || 1;
      const end = (isLastPage ? total : currentPage * limit).toLocaleString();
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
    },
    latest_update_message() {
      const format = "อัปเดตล่าสุดเมื่อวันที่ dd MMMM yyyy เวลา HH:mm น.";

      return toLocaleTH(
        DateTime.fromISO(this.latest_update_time)
      ).toFormat(format);
    }
  },
  created() {
    this.setup();
  },
  watch: {
    "$route.query"() {
      this.setupForm();
      this.setupData();

      this.$refs.pageEl.$el.querySelector(".page-content").scrollTop = 0;
    },
    dateRange(newValue, oldValue) {
      if (!newValue) {
        return
      }

      const [from, to] = newValue;

      if (to.minus({ days: 93 }) > from) {
        alert('ไม่สามารถเลือกเกิน 3 เดือนได้');
        this.dateRange = oldValue;
      }
    }
  },
  methods: {
    setup() {
      this.setupForm();
      this.setupData();
    },
    setupForm() {
      const { from, to, isFilteredByMNC } = this.$route.query;

      this.query = {
        dateType: this.$route.query.dateType || null,
        type: this.$route.query.type || null,
        status: this.$route.query.status || null,
        category: this.$route.query.category || null,
        selectedProject: this.$route.query.selectedProject || null,
        receiptTypeTH: this.$route.query.receiptTypeTH || null,
        companyType: this.$route.query.companyType || null,
        page: this.$route.query.page && this.$route.query.page !== ''
          ? +this.$route.query.page || 1
          : 1,
        documentNumber: this.$route.query.documentNumber || null
      };

      if (from && to) {
        this.dateRange = [DateTime.fromISO(from), DateTime.fromISO(to)];
      } else if (!this.query.documentNumber) {
        const formDateTime = DateTime.utc().setZone('utc+7').startOf('day')
        const toDateTime = formDateTime.endOf('day')

        this.dateRange = [DateTime.fromISO(formDateTime), DateTime.fromISO(toDateTime)];
      }
      this.isFilteredByMNC = (/true/).test(isFilteredByMNC)
    },
    setupData() {
      this.setupReports();
    },
    async setupReports() {
      const result = await this.fetchReports();

      this.reports = result.reports
      this.total = result.total
      this.latest_update_time = result.timestamp ? result.timestamp : null

      this.isAbleButton();
    },
    async fetchReports() {
      const response = await baanRueJaiClient.admin.subscriptions.getReports(
        this.queryParams
      )
      .catch(error => {
        this.reports = []
        this.total = 0
        const message = error.response
          ? error.response.data.message
          : error.message;
        alert(`ไม่สามารถดู Report ได้เนื่องจาก${message ? ` ${message}` : 'ไม่พบข้อมูล'}`);
        this.isAbleButton();
      });
      return response.data.result;
    },
    handleClickSearch() {
      const from = this.dateRange && this.dateRange.length > 1
        ? this.dateRange[0].toISO()
        : undefined

      const to = this.dateRange && this.dateRange.length > 1
        ? this.dateRange[1].toISO()
        : undefined

      const query = {
        from,
        to,
        dateType: this.query.dateType,
        status: this.query.status,
        type: this.query.type,
        category: this.query.category,
        selectedProject: this.selectedProject,
        receiptTypeTH: this.query.receiptTypeTH,
        companyType: this.query.companyType,
        page: 1,
        documentNumber: this.query.documentNumber
      };

      if (this.isFilteredByMNC) {
        query.isFilteredByMNC = this.isFilteredByMNC;
      }

      this.$router.push({ query });
      this.isDisableButton();
    },
    cloneWithEmpty(obj) {
      return Object.keys(obj).reduce((all, key) => ({ ...all, [key]: "" }), {});
    },
    async handleClickDownloadAsCSV(event) {
      event.preventDefault();
      this.isDisableButton();
      const response = await baanRueJaiClient.admin.subscriptions.getReports({
        ...this.queryParams,
        format: "csv"
      });

      const excelBuffer = convertCsvToExcelBuffer(response.data);

      const blob = new Blob([excelBuffer]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `subscription-reports.xlsx`;
      link.click();
      this.isAbleButton();
    },
    async handleClickDownloadWithIncentiveAsCSV(event) {
      event.preventDefault();
      this.isDisableButton();
      this.queryParams.incentiveflag = true;
      const response = await baanRueJaiClient.admin.subscriptions.getReports({
        ...this.queryParams,
        format: "csv"
      });

      const excelBuffer = convertCsvToExcelBuffer(response.data);

      const blob = new Blob([excelBuffer]);
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `subscription-incentive-reports.csv`;
      link.click();
      this.isAbleButton();
    },
    handleClickClear() {
      this.query.dateType = "",
      this.query.status = "",
      this.query.type = "",
      this.query.category = "",
      this.selectedProject = "",
      this.query.receiptTypeTH = "",
      this.query.companyType = "",
      this.query.page = 1,
      this.query.documentNumber = ""
      this.query.isFilteredByMNC = ""
    },
    handleCurrentChange(page) {
      this.isDisableButton();
      const query = { ...this.$route.query, page }

      this.$router.push({ query });
    },
    isDisableButton(){
      this.isSearchDisabled = false,
      this.isClearDisabled = false,
      this.isClickDownloadAsCSVDisabled = false,
      this.isClickDownloadWithIncentiveAsCSVDisabled= false,
      this.isPaginationDisable = false,
      this.isDropdownDisabled = false,
      this.isRouterLinkDisabled = false
    },
    isAbleButton(){
      this.isSearchDisabled = true,
      this.isClearDisabled = true,
      this.isClickDownloadAsCSVDisabled = true,
      this.isClickDownloadWithIncentiveAsCSVDisabled= true,
      this.isPaginationDisable = true,
      this.isDropdownDisabled = true,
      this.isRouterLinkDisabled = true
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.report-container {
  padding: 20px 0;
  width: 100%;
}

.report-row {
  display: grid;
  grid-template-columns: 1fr 4fr;
}

.report-first-price-cell,
.report-price-cell,
.report-cell {
  font-family: sans-serif;
  padding: 1rem 0.5rem;
}

.report-subscription {
  border-left: 1px solid #444;
  border-bottom: 1px solid #444;
}

.report-subscription-row,
.report-subscription-histories-row,
.report-service-row,
.report-appointment-row {
  flex-grow: 1;
  display: grid;
  align-items: stretch;
}

.report-subscription,
.report-subscription-histories,
.report-service,
.report-appointment {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}

.report-appointment {
  border-left: 1px solid #ccc;
}

.report-appointment-row {
  grid-template-columns:
    150px 120px 200px 50px 120px 60px 140px 250px 250px 150px
    250px 120px 120px repeat(4, 150px) repeat(3, 110px) repeat(2, 150px)
    repeat(12, 150px) 180px 150px 180px
    300px 180px 400px 140px 150px repeat(5, 300px) 120px
    repeat(8, 120px) repeat(2, 150px)
    repeat(2, 150px) repeat(4, 300px) 150px;
  &.cancelled,
  &.unsubscribed,
  &.one_time,
  &.free_trial {
    background: #efefef;

    > .status {
      font-weight: bold;
    }
  }

  &.cancelled {
    > .status {
      color: $danger-color;
    }
  }

  &.unsubscribed {
    > .status {
      color: $warning-color;
    }
  }

  &.free_trial {
    > .status {
      color: $secondary-color;
    }
  }

  &.one_time {
    > .status {
      color: $primary-color;
    }
  }
}

.page-container {
  padding: 15px;
}

.report-row:first-child {
  position: sticky;
  top: 0;

  .report-first-price-cell,
  .report-price-cell,
  .report-cell {
    border-top: 1px solid #444;
    font-weight: bold;
    background: #ddd;
  }
}

.report-cell {
  a {
    text-decoration: underline;
  }

  border-bottom: 1px solid #ccc;

  &:not(:first-child) {
    border-left: 1px solid #ccc;
  }

  &:empty::before {
    content: "N/A";
    color: #d8d8d8;
  }
}

.report-first-price-cell,
.report-price-cell {
  &:not(:first-child) {
    border-left: 1px solid #ccc;
  }
}

.report-first-price-cell {
  &:not(:first-child) {
    border-top: 1px solid #ccc;
  }
}

pre.report-group,
pre.report-billing {
  white-space: pre-wrap;
  white-space: -pre-wrap;
  white-space: -o-pre-wrap;
  word-wrap: break-word;
  font-family: sans-serif;
  font-size: 14pt;
  color: #4a4a4a;
}

.space {
  padding-left: 0.8em;
}

.page {
  padding-top: 15px;
  text-align: right;
}

.top-page {
  text-align: right;
  padding-bottom: 10px;
}

.text-document {
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/subscribers/pages/SubscriberReportPage.vue